<template>
  <div class="main row m-0">
    <div class="col-md-6 left-column justify-content-center center" :class="{'index-page': !routing}">
      <header class="d-flex justify-content-center">
        <img v-if="whitelabelReady" class="logo" alt="Omni Business" :src="whitelabelLogo" />
      </header>
      <div class="top-options">
        <span class="return-button" v-if="routing">
          <h6 style="color: white;font-size: 12px;font-weight: 500;cursor: pointer;" @click="back()">{{ $t('generic-str.return') }}</h6>
        </span>
        <span class="return-button" v-else-if="!routing && isYupDomain">
          <a style="color: white;" href="https://yup.chat">{{ $t('app.back-to-website') }}</a>
        </span>
        <span class="return-button" v-else-if="!routing && !isYupDomain">
          <h6 style="color: white;font-size: 12px;font-weight: 500;cursor: pointer;" @click="back()">{{ $t('generic-str.return') }}</h6>
        </span>
      <div class="row justify-content-center align-items-center">
        <p style="margin-right: 10px;margin-bottom: 0px;">Selecione o idioma</p>
        <OptLangDropdown />
      </div>
    </div>
      <div class="row mt-3">
        <template v-if="routing">
          <div class="col-md-12">
            <router-view ref="routerView" />
          </div>
        </template>
        <div class="col-12 sub-intro" v-else :class="{'no-margin-top': !routing}">
          <div class="row mt-3">
            <div class="col-12 col-md-12 mb-4">
              <ButtonComponent @click="routing = true" is-block>{{ $t('app.login') }}</ButtonComponent>
            </div>
            <div class="col-12 col-md-12">
              <ButtonComponent variant="secondary" @click="launchRegister()" is-block>{{ $t('app.register') }} </ButtonComponent>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 right-column d-none d-md-block" :class="{'right-column-yup': isYupDomain}">
      <h3 style="color: white;text-align: center;margin-top: 2em;font-size: 33px;">Bem-vindo ao Omni Business!</h3>
      <aside style="height: 50%;" class="samples d-flex align-items-center justify-content-center">
        <div class="samples-bg">
          <!-- Start SVG -->
          <img src="/assets/img/Vector.svg" alt="Omni Business" />
          <!-- End SVG -->
        </div>
      </aside>
      <p style="text-align: center;
    color: white;
    font-size: 22px;
    font-weight: bold;">Uma maneira mais inteligente de se comunicar</p>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { load } from 'recaptcha-v3';
import DarkMode from '@/assets/mixins/detectDark';
import OptLangRadio from '@/components/OptLangRadio.vue';
import OptLangDropdown from '@/components/OptLangDropdown.vue';
import ButtonComponent from '@/components/ui/ButtonComponent.vue';
import Logo from '@/assets/logo-v2.svg';

export default {
  name: 'AuthIntro',
  components: {
    // OptLangRadio,
    ButtonComponent,
    OptLangDropdown,
  },
  mixins: [DarkMode],
  watch: {
    $route(to, from) {
      // if (from.path === '/2fa') {
      //   this.routing = true;
      // } else if (to.path === '/login') {
      //   this.routing = false;
      // }

      if (to.path === '/login') {
        this.routing = false;
      }
    },
  },
  data() {
    return {
      routing: this.$router.currentRoute.path !== '/login',
      logo: null,
    };
  },
  computed: {
    isYupDomain() {
      return window.location.hostname === 'app.yup.chat' || window.location.hostname === 'localhost';
    },
    whitelabelReady() {
      return !!this.$store?.state?.admin?.whitelabel?.id;
    },
    whitelabelLogo() {
      return this.$store?.state?.admin?.whitelabel?.logo ?? Logo;
    },
    whitelabel() {
      return this.$store?.state?.admin?.whitelabel ?? null;
    },
  },
  mounted() {
    const hostname = window.location.hostname;

    console.log(hostname);

    // Gambiarra para prevenir que os botões troquem de cor repentinamente quando é dominio whitelabel.
    if (hostname !== 'app.yup.chat') {
      const splash = document.createElement('div');
      splash.id = 'splash-screen';
      splash.innerHTML = `
    <div style="
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
    ">
      <div style="
        width: 40px;
        height: 40px;
        border: 4px solid #f3f3f3;
        border-top: 4px solid black;
        border-radius: 50%;
        animation: spin 1s linear infinite;
      "></div>
    </div>
    <style>
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    </style>
  `;
      document.body.appendChild(splash);
      setTimeout(() => {
        splash.remove();
      }, 3500);
    }

    switch (hostname) {
      case 'smsycorporativo.algartelecom.com.br':
        this.companyName = 'Algar Telecom';
        break;
      default:
        console.info('Default favicon');
    }
  },
  methods: {
    async launchRegister() {
      await this.$router.push('/register');
      this.routing = true;
    },
    back() {
      this.$refs.routerView.back();
    },
  },
};
</script>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
.index-page {
  margin-top: 18vh;
}

.no-margin-top {
  margin-top: 0vh !important;
}

.return-button {
  background: var(--clr-yup-purple);
  color: white;
  font-size: 12px;
  padding: 5px 11px;
  border-radius: 100px;
  font-weight: 500;
  max-height: 2.2em;
}

.main {
  height: 100vh;
  padding: 0; // Remove the padding from main

  .top-options {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 3em;
  }

  .left-column {
    background-color: white;
    padding: 53px 37px;

    @media (min-width: 768px) {
      padding: 85px 185px;
    }

    @media (max-width: 1500px) {
      padding: 50px 50px;
    }
  }

  .right-column-yup {
    background: var(--clr-yup-purple-gradient)!important;
  }

  .right-column {
    background: radial-gradient(63.72% 70.71% at 50% 50%, var(--clr-yup-purple) 0%, var(--clr-yup-purple) 100%);
    padding: 39px 23px;

    @media (min-width: 768px) {
      padding: 115px 180px;
    }

    @media (max-width: 1500px) {
      padding: 50px 50px;
    }
  }

  header {
    margin-bottom: 40px;
  }

  .logo {
    width: 126px;
    height: 30px;
  }

  .sub-intro {
    margin-top: 10vh;

    h1 {
      font-size: 23px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-align: center;

      @media (min-width: 768px) {
        font-size: 33px;
        text-align: left;
      }
    }

    h2 {
      color: #747374;
      font-size: 19px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-align: center;

      @media (min-width: 768px) {
        font-size: 17px;
        text-align: left;
      }
    }
  }

  ::v-deep .primary, .secondary {
    height: 53px !important;
    font-weight: 600 !important;
  }
}
</style>
